import afterElementInsert from './after-element-insert';
import afterViewLoad from './after-view-load';
import buildNewMarkup from './build-new-markup';
import extendItemsFieldsActions from './extend-items-fields-actions';
import generateNewFieldData from './generate-new-field-data';
import getCommonConstants from './get-common-constants';
import getComponent from './get-component';
import getFields from './get-fields';
import getFieldSelectors from './get-field-selectors';
import getFieldTemplates from './get-field-templates';
import getFieldTypeOptions from './get-field-type-options';
import getFieldTypes from './get-field-types';
import getGdprCheckboxQuerySelector from './get-gdpr-checkbox-query-selector';
import parseItemsFromDOM from './parse-items-from-dom';
import removeEditableFields from './remove-editable-fields';
import setDefaultAttributes from './set-default-attributes';
import setDerivedAttributes from './set-derived-attributes';
import getFieldTypePlaceholders from './get-field-type-placeholders';
import populateFieldsTitles from './populate-fields-titles';
import getEscapedString from './get-escaped-string';
import getTimeFormat from './get-time-format';
import validatePersonalData from './validate-personal-data';
import encryptString from './encrypt-string';
import latinizeString from './latinize-string';
import sanitizeString from './sanitize-string';
import replaceSymbolsCombinationsWithLetters from './replace-symbols-combinations-with-letters';
import getItemsEditedCount from './get-items-edited-count';
import getItemById from './get-item-by-id';
import getOptionsFieldControlDefaultValue, {
  getMinCountOfOptionsFieldControl,
} from './get-options-field-control-default-value';
import getSupportedFileTypes from './get-supported-file-types';

export default {
  afterElementInsert,
  afterViewLoad,
  buildNewMarkup,
  extendItemsFieldsActions,
  generateNewFieldData,
  getCommonConstants,
  getComponent,
  getFields,
  getFieldSelectors,
  getFieldTemplates,
  getFieldTypeOptions,
  getFieldTypes,
  getGdprCheckboxQuerySelector,
  parseItemsFromDOM,
  removeEditableFields,
  setDefaultAttributes,
  setDerivedAttributes,
  getFieldTypePlaceholders,
  populateFieldsTitles,
  getEscapedString,
  getTimeFormat,
  validatePersonalData,
  encryptString,
  latinizeString,
  sanitizeString,
  replaceSymbolsCombinationsWithLetters,
  getItemsEditedCount,
  getItemById,
  getOptionsFieldControlDefaultValue,
  getMinCountOfOptionsFieldControl,
  getSupportedFileTypes,
};
